import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';


const preview = (
  <div className={`d-inline-block p-5 ${styles.preview}`}>
    <i className={`fa fa-image mb-3 ${styles.previewIcon}`} />
    <p>No image available</p>
  </div>
);

const ImagePreview = ({ src }) => {
  return src ?
    <div className={`${styles.imageContainer}`}> <img className={`${styles.image}`} src={src} /> </div> :
    preview
};

ImagePreview.propTypes = {
  src: PropTypes.string
};

export default ImagePreview;


// WEBPACK FOOTER //
// src/components/shared/ImagePreview/index.jsx